/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_TitleInputs */

const en_directory_agent_readiness_title = /** @type {(inputs: Directory_Agent_Readiness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent Readiness`)
};

const zh_directory_agent_readiness_title = /** @type {(inputs: Directory_Agent_Readiness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 就绪度`)
};

/**
* | output |
* | --- |
* | "Agent Readiness" |
*
* @param {Directory_Agent_Readiness_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_title = /** @type {((inputs?: Directory_Agent_Readiness_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_title(inputs)
	return zh_directory_agent_readiness_title(inputs)
});
export { directory_agent_readiness_title as "directory.agent_readiness.title" }